export default "__VITE_ASSET__CeF7BljV__"